// extracted by mini-css-extract-plugin
module.exports = {"empty":"Empty_empty__Ed6pe","empty_text":"Empty_empty_text__Sgkca"};